import React, { type FC, memo } from "react";
import type { AlternativeType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import Price from "../../../common/price/Price";
import {
    CarConfigStep,
    getCarConfigUrl,
} from "../../../../../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { useCarConfigSelector } from "../../../../../redux/store";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import Button from "../../../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "./SummarySimilarCars.module.scss";
import ETA from "./ETA";

const SummarySimilarCar: FC<{ alternative: AlternativeType }> = ({ alternative }) => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);

    if (!alternative.eta.date) {
        return null;
    }

    return (
        <div className={styles.car}>
            <div>
                <Text variant="apheleia-body" color="grey-7" spacing="spacing-2">
                    <strong>
                        <ETA date={alternative.eta.date} />
                    </strong>
                </Text>
                <Text tag="h3" variant="apheleia-h3" spacing="spacing-1">
                    {alternative.grade.name}
                </Text>
                <Text variant="apheleia-body">
                    {alternative.body.name} - {alternative.motorization.engine.name} -{" "}
                    {alternative.motorization.transmission.name}
                </Text>
                <Text variant="apheleia-price" spacing="spacing-2">
                    <Price price={alternative.price} forceCashPrice />
                </Text>
                <figure>
                    <img
                        src={alternative.carImage.replace("width/160", "width/512").replace("height/160", "height/412")}
                        className={styles.image}
                        alt={alternative.grade.name}
                    />
                </figure>
            </div>
            <Button
                variant="btn-default"
                sizing="full-width"
                href={`${getCarConfigUrl(
                    commonSettings,
                    alternative.model.id,
                    alternative.model.internalCode,
                    alternative.id,
                    CarConfigStep.Configure,
                    { colourId: alternative.colour.id, colourCode: alternative.colour.code },
                    { upholsteryId: alternative.upholstery.id, upholsteryCode: alternative.upholstery.internalCode },
                )}`}
            >
                <CarConfigLabel label="carConfigSimilarCarSelect" />
            </Button>
        </div>
    );
};

export default memo(SummarySimilarCar);
